import { render } from "./Git.vue?vue&type=template&id=04276643&scoped=true"
import script from "./Git.vue?vue&type=script&lang=js"
export * from "./Git.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-04276643"

export default script